let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9X3mK")).then(() => parcelRequire('4EO7y'));